@import '../../global/global.scss';

.swp-chatbot-banner-card {
  border-radius: var(--stamp-spacing-inner-s, 8px);
  background: var(--stamp-color-background-surface, #FFF);
  display: flex;
  gap: var(--stamp-spacing-inner-l, 16px);
  box-shadow: 0px 2px 6px 0px rgba(31, 30, 47, 0.15);
  padding: var(--stamp-spacing-inner-3-xl, 40px) var(--stamp-spacing-inner-xxl, 32px) var(--stamp-spacing-inner-3-xl, 40px) var(--stamp-spacing-inner-xl, 24px);  
  color: var(--stamp-color-heading-subtle, #1F1E2F);
  font-family: "Hanken Grotesk";
  position: relative;
  top: var(--stamp-spacing-inner-3-xl, 40px);

  h3 {
    font-size: 21px;
    font-style: normal;
    font-weight: 700;
    line-height: 105%;
    margin: 0 0 var(--stamp-spacing-inner-s, 8px) 0;
  }

  .swp-chatbot-banner-card-content-text {
    width: 316px;
    font-feature-settings: 'ss01' on, 'ss03' on;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 160%;
    margin-bottom:  var(--stamp-spacing-inner-xxl, 32px);
  }

  .swp-chatbot-banner-card-cta {
    @include primary-button;
    text-align: center;
    font-feature-settings: 'ss01' on, 'ss03' on;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 140%;
    margin-right: auto;
  }  
}

.swp-chatbot-banner-card-img-container {
  display: flex;
  padding: 15px 7px 12px 10px;

  img {
    width: 128px;
    height: 117px;
    flex-shrink: 0;
  }
}

.swp-chatbot-banner-card-content-container {
  display: flex;
  flex-direction: column;

}

@media (width <= 880px) {
  .swp-chatbot-banner-card {
    flex-direction: column;
    padding-top: 0;
    align-items: stretch;
    
    .swp-chatbot-banner-card-cta {
      margin-right: unset;
    }
  }

  .swp-chatbot-banner-card-img-container {
    padding-bottom: 0;
    top:-25px;
    position: relative;

    img {
      flex-shrink: 1;
      margin-left:auto;
      margin-right: auto;
      position: relative;
    }
  }

  .swp-chatbot-banner-card-content-container {
    top:-25px;
    position: relative;
  }
}
